<ng-container *ngIf="ready">
  <div id="toolContent">
    <a
      (click)="navigateBack()"
      href="javascript:void(0)"
      *ngIf="showBackButton"
      class="backwards-navigation"
    >
      <img src="assets/img/back-arrow.png" alt="navigate back" />
    </a>
    <app-content-repeater [items]="content"></app-content-repeater>

    <ng-container
      *ngIf="(isModal$ | async) === false && (isModal$ | async) === false"
    >
      <footer id="toolFooter">
        <span
          ><a href="http://godtoolsapp.com" target="_blank"
            >Learn more at godtoolsapp.com</a
          ></span
        >
        <span
          >© 1994-{{ currentYear }}
          <a href="http://cru.org" target="_blank">Cru</a>. All Rights
          Reserved.</span
        >
      </footer>
    </ng-container>
  </div>
</ng-container>
